import { useState, useEffect, Suspense } from "react";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import jwt_decode from "jwt-decode";
// Components
import Loader from "./components/loader";
import I18Next from "./i18n";

function App() {
  const [language, setLanguage] = useState("English");
  const [token] = useState(window.location.pathname.split("/")[2]);

  // Set language
  useEffect(() => {
    if (token) {
      const patientData = jwt_decode(token);
      const patientLanguage = patientData.data.LANGUAGE;
      const languages = [
        "English",
        "Spanish",
        "Catalan",
        "Portuguese",
        "French",
        "Italian",
        "Romanian",
        "Dutch",
        "German",
        "Ukrainian",
        "Chinese",
        "ChineseTraditional",
      ];
      setLanguage(languages.includes(patientLanguage) ? patientLanguage : "English");
    }
  }, [token]);

  return (
    <Suspense fallback={<Loader />}>
      <I18Next language={language} />
    </Suspense>
  );
}

export default App;
